export default __webpack_public_path__ + "static/media/twitter.ace81f2a.svg";